import React from 'react';
import { CollectionSectionProps } from '.';

const ModuleSectionContext = React.createContext(
	{} as Omit<CollectionSectionProps, 'containerProps'>
);

export default ModuleSectionContext;
